import { jsx as e, jsxs as N } from "react/jsx-runtime";
import r from "../../../node_modules/prop-types/index.es.js";
import { forwardRef as f } from "react";
import * as l from "./style.es.js";
import { NameAvatar as d, NameAvatarContainer as v, NameAvatarText as c } from "./style.es.js";
import { COMPONENT_SIZE as t } from "../../../constants/sizes.es.js";
const a = f(({
  name: m,
  rounded: o = !0,
  size: s = t.md
}, p) => {
  const [i, n] = m.split(" ");
  return /* @__PURE__ */ e(d, { size: s, className: "name-avatar-wrapper", rounded: o, ref: p, children: /* @__PURE__ */ e(v, { children: /* @__PURE__ */ N(c, { children: [
    i[0],
    n[0]
  ] }) }) });
}), A = {
  name: r.string.isRequired,
  size: r.oneOfType([r.oneOf(Object.values(t)), r.number]),
  rounded: r.bool
};
a.S = l;
a.displayName = "NameAvatar";
a.propTypes = A;
export {
  a as NameAvatar,
  A as nameAvatarPropTypes
};
//# sourceMappingURL=NameAvatar.es.js.map
